<template>
  <bds-scroll-area component-class="content-scroll-area specific-height">
    <product-category-item :data-param="newCategory" :key="newCategory.id"/>
    <product-category-item v-for="category of this.categories" :data-param="category" :key="category.id"/>
  </bds-scroll-area>
</template>

<script>

import ProductCategoryService from "@/services/ProductCategory.service";
import {ProductCategory} from "@/models/ProductCategory.model";
import ProductCategoryItem from "@/views/settings/ProductCategoryItem.vue";
import { showErrorNotify } from "@/helpers/functionsHelpers";

export default {
  components: {
    ProductCategoryItem
  },
  name: "product-categories",
  data() {
    return {
      newCategory: null,
    };
  },
  computed: {
    isSmallerScreen () {
      return this.$store.state.windowWidth < 768
    },
    categories() {
      return this.$store.getters['ProductCategory/listCategories'];
    }
  },
  methods: {

  },
  created() {
    this.newCategory = new ProductCategory();
  },
  mounted: function() {
    ProductCategoryService.getProductCategories().then((response) => {
      console.debug("Listing product Categories data...");
      this.$store.dispatch('ProductCategory/setCategories', response);
    }, (error) => {
      showErrorNotify(this, error);
    });
  }
}
</script>

<style lang="scss">
.content-scroll-area.specific-height {
  height: calc(100% - 4rem);
}

@media screen and (min-width: $screen-md-min) {
  .content-scroll-area.specific-height {
    height: calc(100%);
  }
}
</style>
